import {createUseStyles} from 'react-jss';
import cn from 'classnames';
import React, {FunctionComponent} from 'react';
import {IconProps} from './IconProps';

const IconMasterCard: FunctionComponent<IconProps> = ({className, height = '1em'}) => {
  const styles = useStyles();

  return (
    <svg height={height} viewBox="0 0 29 19" fill="none" xmlns="http://www.w3.org/2000/svg"
      className={cn('inline-block', className, styles.icon)}>
      <path
        d="M0 3.5625C0 1.59499 1.59499 0 3.5625 0H24.9375C26.905 0 28.5 1.59499 28.5 3.5625V15.4375C28.5 17.405 26.905 19 24.9375 19H3.5625C1.59499 19 0 17.405 0 15.4375V3.5625Z"
        fill="white"/>
      <path d="M16.5929 5.1521H11.3755V13.4998H16.5929V5.1521Z" fill="#FF5F00"/>
      <path
        d="M12.1053 9.49914C12.104 7.8451 12.861 6.28232 14.1581 5.26109C11.9545 3.52394 8.79002 3.77697 6.88859 5.84236C4.98717 7.90774 4.98717 11.092 6.88859 13.1574C8.79002 15.2228 11.9545 15.4758 14.1581 13.7387C12.8606 12.7171 12.1035 11.1537 12.1053 9.49914Z"
        fill="#EB001B"/>
      <path
        d="M22.8537 9.50064C22.8537 11.5645 21.6788 13.4472 19.8281 14.3492C17.9773 15.2511 15.7757 15.0138 14.1581 13.7382C15.4546 12.7162 16.2115 11.1538 16.2115 9.49989C16.2115 7.84594 15.4546 6.28354 14.1581 5.26155C15.7757 3.98594 17.9773 3.74872 19.8281 4.65063C21.6788 5.55254 22.8537 7.43524 22.8537 9.49914V9.50064Z"
        fill="#F79E1B"/>
      <path
        d="M3.5625 1H24.9375V-1H3.5625V1ZM27.5 3.5625V15.4375H29.5V3.5625H27.5ZM24.9375 18H3.5625V20H24.9375V18ZM1 15.4375V3.5625H-1V15.4375H1ZM3.5625 18C2.14727 18 1 16.8527 1 15.4375H-1C-1 17.9573 1.0427 20 3.5625 20V18ZM27.5 15.4375C27.5 16.8527 26.3527 18 24.9375 18V20C27.4573 20 29.5 17.9573 29.5 15.4375H27.5ZM24.9375 1C26.3527 1 27.5 2.14727 27.5 3.5625H29.5C29.5 1.0427 27.4573 -1 24.9375 -1V1ZM3.5625 -1C1.0427 -1 -1 1.0427 -1 3.5625H1C1 2.14727 2.14727 1 3.5625 1V-1Z"
        fill="#CDCDCD"/>
    </svg>

  );
};

export default IconMasterCard;

const useStyles = createUseStyles({
  icon: {
    verticalAlign: '-0.125em',
  },
});
